/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * Tab key/index model for the Add/Assigned resource tab panel. Add is the
 * initial active tab (index 0); Assigned is index 1.
 */
export const TAB_PANEL_MODEL = {
    ADD: 0,
    ASSIGNED: 1,
};
